import * as API from '../data/account_invoice_api';
import {signOutAction} from "./auth_actions";

export const GET_INVOICE_LIST = "get_invoices";
export const GET_INVOICE_ESTIMATES_LIST = "get_invoice_estimate_list";
export const CLEAR_DATA = "clear_loaded_data";
export const GET_INVOICE_DETAIL = "get_invoice_detail";
export const GET_ESTIMATE_DETAIL = "get_estimate_detail";

export function getInvoiceList(startDate,endDate) {
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.getInvoices(startDate,endDate);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_INVOICE_LIST,
                payload: response.data
            });
        }
    };
}

export function getInvoiceEstimates() {
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.getInvoiceEstimateList();
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_INVOICE_ESTIMATES_LIST,
                payload: response.data
            });
        }
    };
}


export function getInvoiceDetails(id) {
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.getInvoiceDetail(id);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_INVOICE_DETAIL,
                payload: response.data.invoice
            });
        }
    };
}

export function getEstimateDetails(id) {
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.getEstimateDetails(id);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_ESTIMATE_DETAIL,
                payload: response.data['invoice_estimate']
            });
        }
    };
}

export function changeInvoiceStatus(status,invoiceId,successCallBack) {
    return async (dispatch) => {
        const response = await API.changeInvoiceStatus(status);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch(getInvoiceDetails(invoiceId));
            successCallBack(response.data);
        }
    };
}



export function updateAdjustment(formData,actionType,successCallBack,estimateId) {
    return async (dispatch) => {
        const response = await API.updateAdjustment(formData,actionType);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response.data);
        }
        dispatch(getEstimateDetails(estimateId))
    };
}


export function deleteAdjustment(adjustmentId,successCallBack,estimateId){
    return async (dispatch) => {
        const response = await API.deleteAdjustment(adjustmentId);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response.data);
        }
        dispatch(getEstimateDetails(estimateId))
    }
}

export function regenerateInvoice(invoiceId,successCallBack){
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.regenerateInvoice(invoiceId);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response.data);
            dispatch({
                type: GET_INVOICE_DETAIL,
                payload: response.data.invoice
            });
        }
    }
}

export function sendInvoiceMail (invoiceId,successCallBack){
    return async (dispatch) => {
        const response = await API.sendInvoiceMail(invoiceId);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response.data);
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/account_invoice_action.js